const selectDeviceModelInputs = state => state.data.deviceModelInputs

const DeviceModelInputDataStoreSelectors = {
  deviceModelInputs: selectDeviceModelInputs
}

export default DeviceModelInputDataStoreSelectors
